const validate = (values, props) => {
    let errors = {}
    const { messages, deliveryDuty, checkoutAnalytics } = props
    if (deliveryDuty === 'DDU' && !(values.acceptAdditionalCosts === 'true')) {
        errors.acceptAdditionalCosts = messages.errors.required({})
    }

    return { ...errors, checkoutAnalytics }
}

export default validate